<template>
  <div class="chapterOne">     
      <h1 style="textAlign:center;marginTop:55px;">欢迎来到AI课程</h1>
      <!-- <div style="textAlign:center;marginTop:25px;"><span style="marginRight:20px;">正确率</span><span style="marginLeft:20px;">练习率</span></div>
      <div style="textAlign:center;marginTop:5px;"><span style="marginRight:25px;">x%</span><span style="marginLeft:25px;">y/25</span></div> -->
      <div style="display:flex;marginTop:20px;">
          <div style="flex:1;">
              <div>第1章</div>
              <div style="fontSize:22px;fontWeight:bold;">AI是什么？</div>
              <div @click="lesson1" style="color:#0090ff;">1. <span style="textDecoration:underline;cursor:pointer;">如何定义AI？</span><span style="float:right;marginRight:20px;">0/1</span></div>
              <div @click="lesson2" style="color:#0090ff;">2. <span style="textDecoration:underline;cursor:pointer;"> AI相关领域</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson3" style="color:#0090ff;">3. <span style="textDecoration:underline;cursor:pointer;">AI哲学</span><span style="float:right;marginRight:20px;">0/1</span></div>
          </div>
          <div style="flex:1;">
              <div>第2章</div>
              <div style="fontSize:22px;fontWeight:bold;">AI问题求解</div>
              <div @click="lesson4" style="color:#0090ff;">4. <span style="textDecoration:underline;cursor:pointer;"> 搜索和问题求解</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson5" style="color:#0090ff;">5. <span style="textDecoration:underline;cursor:pointer;"> 用AI解决问题</span><span style="float:right;marginRight:20px;">---</span></div>
              <div @click="lesson6" style="color:#0090ff;">6. <span style="textDecoration:underline;cursor:pointer;">搜索和游戏</span><span style="float:right;marginRight:20px;">0/1</span></div>
          </div>
          <div style="flex:1;">
              <div>第3章</div>
              <div style="fontSize:22px;fontWeight:bold;">真实世界中的AI</div>
              <div @click="lesson7" style="color:#0090ff;">7. <span style="textDecoration:underline;cursor:pointer;">概率和优势比</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson8" style="color:#0090ff;">8. <span style="textDecoration:underline;cursor:pointer;"> 贝叶斯规则</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson9" style="color:#0090ff;">9. <span style="textDecoration:underline;cursor:pointer;">朴素贝叶斯分类</span><span style="float:right;marginRight:20px;">0/2</span></div>
          </div>
      </div>
      <div style="display:flex;marginTop:20px;">
          <div style="flex:1;">
              <div>第4章</div>
              <div style="fontSize:22px;fontWeight:bold;">机器学习</div>
              <div @click="lesson10" style="color:#0090ff;">10. <span style="textDecoration:underline;cursor:pointer;">机器学习的类型</span><span style="float:right;marginRight:20px;">---</span></div>
              <div @click="lesson11" style="color:#0090ff;">11. <span style="textDecoration:underline;cursor:pointer;"> 最近邻分类器</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson12" style="color:#0090ff;">12. <span style="textDecoration:underline;cursor:pointer;">回归</span><span style="float:right;marginRight:20px;">0/4</span></div>
          </div>
          <div style="flex:1;">
              <div>第5章</div>
              <div style="fontSize:22px;fontWeight:bold;">神经网络</div>
              <div @click="lesson13" style="color:#0090ff;">13. <span style="textDecoration:underline;cursor:pointer;">神经网络基础</span><span style="float:right;marginRight:20px;">0/1</span></div>
              <div @click="lesson14" style="color:#0090ff;">14. <span style="textDecoration:underline;cursor:pointer;"> 如何构建神经网络</span><span style="float:right;marginRight:20px;">0/2</span></div>
              <div @click="lesson15" style="color:#0090ff;">15. <span style="textDecoration:underline;cursor:pointer;">先进的神经网络技术</span><span style="float:right;marginRight:20px;">---</span></div>
          </div>
          <div style="flex:1;">
              <div>第6章</div>
              <div style="fontSize:22px;fontWeight:bold;">AI的影响</div>
              <div @click="lesson16" style="color:#0090ff;">16. <span style="textDecoration:underline;cursor:pointer;"> 预测未来</span><span style="float:right;marginRight:20px;">0/1</span></div>
              <div @click="lesson17" style="color:#0090ff;">17. <span style="textDecoration:underline;cursor:pointer;">  AI的社会影响</span><span style="float:right;marginRight:20px;">0/1</span></div>
              <div @click="lesson18" style="color:#0090ff;">18. <span style="textDecoration:underline;cursor:pointer;">总结</span><span style="float:right;marginRight:20px;">0/1</span></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods:{
      lesson1(){
          this.$router.push('/chapterOne');
      },
      lesson2(){
          this.$router.push('/chapterTow');
      },
      lesson3(){
          this.$router.push('/chapterThree');
      },
      lesson4(){
          this.$router.push('/chapterFour');
      },
      lesson5(){
          this.$router.push('/chapterFive');
      },
      lesson6(){
          this.$router.push('/chapterSix');
      },
      lesson7(){
          this.$router.push('/chapterSeven');
      },
      lesson8(){
          this.$router.push('/chapterEight');
      },
      lesson9(){
          this.$router.push('/chapterNine');
      },
      lesson10(){
          this.$router.push('/lessonTen');
      },
      lesson11(){
          this.$router.push('/lessonEleven');
      },
      lesson12(){
          this.$router.push('/lessonTwelve');
      },
      lesson13(){
          this.$router.push('/lessonThirteen');
      },
      lesson14(){
          this.$router.push('/lessonFourteen');
      },
      lesson15(){
          this.$router.push('/lessonFifteen');
      },
      lesson16(){
          this.$router.push('/lessonSixteen');
      },
      lesson17(){
          this.$router.push('/lessonSeventeen');
      },
      lesson18(){
          this.$router.push('/lessonEighteen');
      },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/catalog.vue